import axios from "axios";

function getPolicy(policyId) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/get_policy/${policyId}`, {
        headers: {
          'Accept': 'application/json, text/plain, */*',
        },
        timeout: 9000000,
      });
      
      if (response.data && response.data.status === "200") {
        resolve(response.data);
      } else {
        reject(new Error("Invalid response from policy API"));
      }
    } catch (err) {
      console.error("Error fetching policy:", err);
      reject(err);
    }
  });
}

export const policyService = {
  getPolicy,
};

